import { ReferenceError, addClass, append, before, classList, cloneNode, createComment, removeChildNodes, replace, } from "@acng/frontend-bounty";
import { ResourceUtility } from "./resource.js";
import { Widget } from "../widget.js";
import { REGISTRY_ELEMENT, RENDERED_ELEMENTS, RENDERED_TEXTNODES } from "../resource.js";
import { render } from "../../service/render.js";
const RENDERED_RESOURCE = Symbol();
/**
 * @typedef {Record<string, unknown>} RenderHost
 * @property {() => HTMLElement} createRenderRoot
 * @property {(template: TemplateUtility<any, any>) => void} render
 */
/**
 * @template {{[key: string]: Element}} [R = {[key: string]: Element}]
 * @template {{[key: string]: Text}} [N = {[key: string]: Text}]
 */
export class TemplateUtility extends ResourceUtility {
    get template() {
        const template = this[RENDERED_RESOURCE];
        if (!template) {
            throw ReferenceError();
        }
        return template;
    }
    get elements() {
        return /** @type {R} */ (this.template[RENDERED_ELEMENTS]);
    }
    get textNodes() {
        return /** @type {N} */ (this.template[RENDERED_TEXTNODES]);
    }
    get content() {
        return this.template.content;
    }
    /**
     * @template {HTMLElement} T
     * @param {T} target
     * @param {(template: TemplateUtility<R, N>, target: T) => void} [callback]
     * @returns {T}
     * TODO dies könnte vielleicht alles in render passieren wenn target von createRenderRoot zurückgegeben wird
     */
    apply(target, callback) {
        const template = render(this[REGISTRY_ELEMENT], /** @type {{[key: string]: any}} */ (target));
        this[RENDERED_RESOURCE] = template;
        if (target instanceof Widget) {
            target.render(this);
        }
        callback?.(this, target);
        removeChildNodes(target);
        addClass(target, ...classList(template));
        append(target, template.content);
        return target;
    }
    /**
     * @param {{[key: string]: unknown}} params
     * @returns {HTMLTemplateElement}
     */
    render(params) {
        return this[RENDERED_RESOURCE] = render(this[REGISTRY_ELEMENT], params);
    }
    /**
     * @template T
     * @param {Element} master
     * @param {Iterable<T>} iterable
     * @param {(item: T) => void}  callback
     * @param {(item: T, clone: Element) => void} [postprocess]
     */
    repeatElement(master, iterable, callback, postprocess) {
        const A = createComment();
        const B = createComment();
        replace(master, A, B);
        for (const item of iterable) {
            callback(item);
            const element = cloneNode(master);
            before(B, element);
            postprocess?.(item, element);
        }
    }
}
